<div class="timeline pt-2 mt-2">
  <div class="row" *ngIf="!isSimplify; else simplifyContent">
    <div class="col-md-2">
      <h6 *ngIf="userType === 'Beneficiary'"> <span class="pi pi-sitemap "></span> <span
          class="common-bene-class-for-translation">Timeline</span> </h6>
    </div>
    <div class="col-md-9">
      <div class="ml-auto pb-3 pull-right">
        <div class="mr-3 float-left d-flex align-items-center">
          <div class="float-left mr-2 legend completed"></div>
          <div class="float-left"><span class="common-bene-class-for-translation">Completed</span></div>
        </div>
        <div class="mr-3 float-left d-flex align-items-center">
          <div class="float-left mr-2 legend submitted"></div>
          <div class="float-left"><span class="common-bene-class-for-translation">Submitted</span></div>
        </div>
        <div class="mr-3 float-left d-flex align-items-center">
          <div class="float-left mr-2 legend inprogress"></div>
          <div class="float-left"><span class="common-bene-class-for-translation">In-Progress</span></div>
        </div>
        <div class="mr-3 float-left d-flex align-items-center">
          <div class="float-left mr-2 legend news"></div>
          <div class="float-left"><span class="common-bene-class-for-translation">New</span></div>
        </div>
        <div class="float-left d-flex align-items-center">
          <div class="float-left mr-2 legend over-due"></div>
          <div class="float-left"><span class="common-bene-class-for-translation">Over Due</span></div>
        </div>
      </div>
    </div>
    <div class="col-md-1">
      <help-video-overlay-library #helpVideoComponent *ngIf="userType === 'Beneficiary'"></help-video-overlay-library>
    </div>
  </div>
  <ng-template #simplifyContent>
    <div class="row">
      <div class="col-md-2">
        <h6 *ngIf="userType === 'Beneficiary'"> <span class="pi pi-sitemap "></span> <span
            class="common-bene-class-for-translation">Timeline</span> </h6>
      </div>
      <!-- <div class="col-md-9">
        <div class="ml-auto pb-3 pull-right">
          <div class="mr-3 float-left d-flex align-items-center">
            <div class="float-left mr-2 legend completed"></div>
            <div class="float-left"><span>Completed</span></div>
          </div>
          <div class="mr-3 float-left d-flex align-items-center">
            <div class="float-left mr-2 legend submitted"></div>
            <div class="float-left"><span>Submitted</span></div>
          </div>
          <div class="mr-3 float-left d-flex align-items-center">
            <div class="float-left mr-2 legend inprogress"></div>
            <div class="float-left"><span>In-Progress</span></div>
          </div>
          <div class="mr-3 float-left d-flex align-items-center">
            <div class="float-left mr-2 legend news"></div>
            <div class="float-left"><span>New</span></div>
          </div>
          <div class="float-left d-flex align-items-center">
            <div class="float-left mr-2 legend over-due"></div>
            <div class="float-left"><span>Over Due</span></div>
          </div>
        </div>
      </div>
      <div class="col-md-1">
        <help-video-overlay-library #helpVideoComponent *ngIf="userType === 'Beneficiary'"></help-video-overlay-library>
      </div> -->
    </div>
  </ng-template>

  <div class="container" style="width: 70%;" *ngIf="!isSimplify; else simplifytimeLineHead">
    <div *ngIf="!primaryData.isBeneficiaryInitiate" class="row timeline-row">
      <div class="col justify-content-center col-styled col-bene">
        <span class="time-title common-bene-class-for-translation">
          {{ primaryData.caseType === 'I130' ? 'Sponsor Actions' : 'Beneficiary Actions'}}
        </span>
      </div>
      <div class="col justify-content-center col-styled col-att">
        <span class="time-title common-bene-class-for-translation">
          {{ primaryData.caseType === 'I130' ? 'Lawfirm Actions' : 'Petitioner / Lawfirm Actions'}}
        </span>
      </div>
    </div>
    <div *ngIf="primaryData.isBeneficiaryInitiate" class="row timeline-row">
      <div class="col justify-content-center col-styled col-bene">
        <span class="time-title common-bene-class-for-translation">
          Timeline Steps
        </span>
      </div>
    </div>
  </div>
  <ng-template #simplifytimeLineHead>
    <div class="container timeLinemainHeader">
      <div class="row timeLineHeader">
        <div class="col-6 subTimeLine">
          <ul>
            <li class="pl-2">
              <label class="m-0 common-bene-class-for-translation">{{ primaryData.caseType === 'I130' ? 'Sponsor
                Actions' : 'Individual Actions'}}</label>
            </li>
          </ul>
        </div>
        <div class="col-6 subTimeLine">
          <ul class="customAction">
            <li class="pl-2">
              <label class="m-0 common-bene-class-for-translation">{{ primaryData.caseType === 'I130' ? 'Lawfirm
                Actions' : 'Petitioner / Lawfirm Actions'}}</label>
            </li>
          </ul>
        </div>
        <!-- <div class="col justify-content-center col-styled col-bene">
          <span class="time-title">
            <mat-icon>visibility</mat-icon>
            {{ primaryData.caseType === 'I130' ? 'Sponsor Actions' : 'Individual Actions'}}
          </span>
        </div>
        <div class="col justify-content-center col-styled col-att">
          <span class="time-title">
            <mat-icon>touch_app</mat-icon>
            {{ primaryData.caseType === 'I130' ? 'Lawfirm Actions' : 'Petitioner / Lawfirm Actions'}}
          </span>
        </div> -->
      </div>
    </div>
  </ng-template>
  <div class="container timeline-action">
    <div class="row timeline-row">
      <div class="col justify-content-center"></div>
      <div class="col justify-content-center">
        <hr class="separator timeline-separator">
      </div>
      <div class="col justify-content-center"></div>
    </div>
  </div>
  <p-timeline *ngIf="!primaryData?.isBeneficiaryInitiate" [value]="stepList">
    <ng-template pTemplate="marker" let-step>
      <span class="custom-marker" (mouseenter)="mouseEnter(step?.completionStatus)">
        <span *ngIf="!step.isCustomStep" [ngbTooltip]="step?.estimatedTime" [tooltipClass]="toolTipCustomClass"
          [ngClass]="{'complete-icon':step?.stepStatusDetails?.stepStatusCode==='COMPLETE',
              'inprogress-icon': step?.stepStatusDetails?.stepStatusCode === 'INPROGRESS', 
              'new-icon':step?.stepStatusDetails?.stepStatusCode === 'NEW', 
              'submit-icon':step?.stepStatusDetails?.stepStatusCode === 'SUBMIT',
            'overDue-icon': step?.completionStatus === 'OVERDUE' }">
        </span>
        <span *ngIf="step.isBeneficiaryVisible && step.isCustomStep" [ngbTooltip]="step?.estimatedTime"
          [tooltipClass]="toolTipCustomClass" [ngClass]="{'complete-icon':step?.stepStatusCode==='COMPLETE',
              'inprogress-icon': step?.stepStatusCode === 'INPROGRESS', 
              'new-icon':step?.stepStatusCode === 'NEW', 
              'submit-icon':step?.stepStatusCode === 'SUBMIT',
            'overDue-icon': step?.completionStatus === 'OVERDUE' }">
        </span>
      </span>
    </ng-template>
    <ng-template pTemplate="content" let-step>
      <!-- Lawfirm / Petitioner Side -->
      <div class="d-inline-flex"
        *ngIf="(step.isPetitionerAction === 1 || step.isAttorneyAction === 1) && (step.isVisible || step.isAttorneyVisible || step.isPetitionerVisible)">
        <hr class="separator">
        <!-- IM-20492 bcz of this story comments lock  -->
        <!-- <span class="pet-lock-unlock" *ngIf="userType === 'Petitioner' || userType === 'Attorney'">
          <div class="icon-lock-background locks task-notes-btn" [pTooltip]="step?.isBeneficiaryVisible === 0 ? 'Step Locked For Beneficiary' : 'Lock Step For Beneficiary'"
         #btnNote (click)="lockpanel.toggle($event, btnNote)">
            <span *ngIf="step?.isBeneficiaryVisible === 0" class="icn-lock"></span> <span *ngIf="step?.isBeneficiaryVisible === 1" class="icn-unlock"></span>
          </div>
          <p-overlayPanel #lockpanel appendTo="btnNote" class="lockpanel-pet" [showCloseIcon]="true" [dismissable]="true">
            <ng-template pTemplate>
              <lock-unlock-steps-library [step]="step" (lockUnlock)="updateLockUnlock($event, step)"></lock-unlock-steps-library>
            </ng-template>
          </p-overlayPanel>
          <hr class="pet-separator">
        </span> -->
        <div *ngIf="!step.isCustomStep" class=" p-shadow-2"
          [ngClass]="{'completed-border':step?.stepStatusDetails?.stepStatusCode==='COMPLETE','inprogress-border': step?.stepStatusDetails?.stepStatusCode === 'INPROGRESS', 'new-border':step?.stepStatusDetails?.stepStatusCode === 'NEW', 'submit-border':step?.stepStatusDetails?.stepStatusCode === 'SUBMIT' }">
          <button
            [ngClass]="{'complete':step?.stepStatusDetails?.stepStatusCode==='COMPLETE','inprogress': step?.stepStatusDetails?.stepStatusCode === 'INPROGRESS', 'new':step?.stepStatusDetails?.stepStatusCode === 'NEW', 'submit':step?.stepStatusDetails?.stepStatusCode === 'SUBMIT', 'not-editable': !step.isEditable}"
            (click)="step.isEditable && handleStepClick(step)"
            [class.lock]="step?.isAttorneyEditable === 0 && step?.isPetitionerEditable === 0"><span
              class="common-bene-class-for-translation">
              {{ step.stepName == 'Print Petition' ? 'Send for Signature & Generate Final' : (step.stepName == 'Print
              I-130 Petition' ? 'Send for Signature & Generate Final' : step.stepName) }}</span></button>
        </div>
        <div class=" p-shadow-2" *ngIf="step.isCustomStep"
          [ngClass]="{'completed-border':step?.stepStatusCode==='COMPLETE','inprogress-border': step?.stepStatusCode === 'INPROGRESS', 'new-border':step?.stepStatusCode === 'NEW', 'submit-border':step?.stepStatusCode === 'SUBMIT' }">
          <button
            [ngClass]="{'complete':step?.stepStatusCode==='COMPLETE','inprogress': step?.stepStatusCode === 'INPROGRESS', 'new':step?.stepStatusCode === 'NEW', 'submit':step?.stepStatusCode === 'SUBMIT', 'not-editable': !step.isEditable}"
            (click)="handleStepClick(step)"><span class="common-bene-class-for-translation">
              {{ step.stepName }}</span></button>
        </div>
        <!-- Step Notes -->
        <span id="customCaseView" *ngIf="userType === 'Petitioner' || userType === 'Attorney'">
          <button class="btn dropDownOptions dropdown-toggle" type="button" id="dropdownMenuButton"
            data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
            <i class="fa fa-ellipsis-v"></i>
          </button>
          <div class="dropdown-menu pull-right" aria-labelledby="dropdownMenuButton">
            <div>
              <div class="icon-background notes task-notes-btn" [pTooltip]="step?.notes?.noteText"
                [class.yellow]="step?.notesAvailable===true" #btnNote (click)="notepanel.toggle($event, btnNote)">
                <span class="icn-note"></span>
              </div><span>Notes</span>
            </div>
            <div class="menuSubItems" (click)="onClickNofifications(step)">
              <mat-icon>notifications</mat-icon><span>Notification</span>
            </div>
          </div>

          <!-- <div class="icon-background notes task-notes-btn" [pTooltip]="step?.notes?.noteText"
            [class.yellow]="step?.notesAvailable===true" #btnNote (click)="notepanel.toggle($event, btnNote)">
            <span class="icn-note"></span>
          </div> -->
          <p-overlayPanel #notepanel appendTo="btnNote" class="notepanel" [showCloseIcon]="true" [dismissable]="true">
            <ng-template pTemplate>
              <task-notes-lib [step]="step" (noteAdded)="updateNoteAvailability($event, step)"></task-notes-lib>
              <!-- <app-task-notes-reworked [step]="step" (noteAdded)="updateNoteAvailability($event, step)"></app-task-notes-reworked> -->
            </ng-template>
          </p-overlayPanel>
        </span>
        <!-- End -->
        <!-- Notice & Receipts -->
        <span *ngIf="step.stepName == 'Get Receipt' && !isTaskReceiptDateAvailabel && taskStatus === 'FILED'">
          <div class="icon-background">
            <i class="material-icons text-primary">hourglass_empty</i>
          </div>
          <span *ngIf="receiptETADateRange">
            <div class="d-inline-block align-bottom">
              <small>
                <div>Receipt ETA</div>
                <div class="d-inline-block text-primary">{{receiptETADateRange}}</div>
              </small>
            </div>
          </span>
          <span *ngIf="!receiptETADateRange" class="text-secondary">
            <small>Not Available</small>
          </span>
        </span>
        <!-- End -->
      </div>
    </ng-template>
    <ng-template pTemplate="opposite" let-step>
      <!-- Beneficiary Side -->
      <div class="d-inline-flex" *ngIf="step.isBeneficiaryAction === 1 && step.isVisible && !step.isCustomStep">
        <!-- Step Lock /Unlock -->
        <span *ngIf="userType === 'Petitioner' || userType === 'Attorney'">
          <div class="icon-lock-background locks task-notes-btn"
            [pTooltip]="step?.isBeneficiaryVisible === 0 ? 'Step Locked For Beneficiary' : 'Lock Step For Beneficiary'"
            #btnNote (click)="lockpanel.toggle($event, btnNote)">
            <span *ngIf="step?.isBeneficiaryVisible === 0" class="icn-lock"></span> <span
              *ngIf="step?.isBeneficiaryVisible === 1" class="icn-unlock"></span>
          </div>
          <p-overlayPanel #lockpanel appendTo="btnNote" class="lockpanel" [showCloseIcon]="true" [dismissable]="true">
            <ng-template pTemplate>
              <lock-unlock-steps-library [step]="step"
                (lockUnlock)="updateLockUnlock($event, step)"></lock-unlock-steps-library>
            </ng-template>
          </p-overlayPanel>
        </span>
        <!-- End -->
        <div class="p-shadow-2"
          [ngClass]="{'completed-border-ben':step?.stepStatusDetails?.stepStatusCode==='COMPLETE','inprogress-border-ben': step?.stepStatusDetails?.stepStatusCode === 'INPROGRESS', 'new-border-ben':step?.stepStatusDetails?.stepStatusCode === 'NEW', 'submit-border-ben':step?.stepStatusDetails?.stepStatusCode === 'SUBMIT' }">
          <button [disabled]="userType === 'Petitioner' || userType === 'Attorney'"
            [ngClass]="{'complete':step?.stepStatusDetails?.stepStatusCode==='COMPLETE','inprogress': step?.stepStatusDetails?.stepStatusCode === 'INPROGRESS', 'new':step?.stepStatusDetails?.stepStatusCode === 'NEW', 'submit':step?.stepStatusDetails?.stepStatusCode === 'SUBMIT', 'not-editable': !step.isEditable }"
            (click)="step.isEditable && handleStepClick(step)" [class.lock]="step?.isBeneficiaryVisible === 0">
            <span class="common-bene-class-for-translation"> {{ step.stepName == 'Print Petition' ? 'Send for Signature
              & Generate Final' : (step.stepName == 'Print I-130 Petition' ? 'Send for Signature & Generate Final' :
              step.stepName) }}</span></button>
        </div>
        <hr class="separator">
      </div>
      <div class="d-inline-flex"
        *ngIf="step.isBeneficiaryAction === 1 && step.isBeneficiaryVisible && step.isCustomStep">
        <!-- Step Lock /Unlock -->
        <span *ngIf="userType === 'Petitioner' || userType === 'Attorney'">
          <div class="icon-lock-background locks task-notes-btn"
            [pTooltip]="step?.isBeneficiaryVisible === 0 ? 'Step Locked For Beneficiary' : 'Lock Step For Beneficiary'"
            #btnNote (click)="lockpanel.toggle($event, btnNote)">
            <span *ngIf="step?.isBeneficiaryVisible === 0" class="icn-lock"></span> <span
              *ngIf="step?.isBeneficiaryVisible === 1" class="icn-unlock"></span>
          </div>
          <p-overlayPanel #lockpanel appendTo="btnNote" class="lockpanel" [showCloseIcon]="true" [dismissable]="true">
            <ng-template pTemplate>
              <lock-unlock-steps-library [step]="step"
                (lockUnlock)="updateLockUnlock($event, step)"></lock-unlock-steps-library>
            </ng-template>
          </p-overlayPanel>
        </span>
        <!-- End -->
        <div class="p-shadow-2" *ngIf="step.isCustomStep"
          [ngClass]="{'completed-border-ben':step?.stepStatusCode==='COMPLETE','inprogress-border-ben': step?.stepStatusCode === 'INPROGRESS', 'new-border-ben':step?.stepStatusCode === 'NEW', 'submit-border-ben':step?.stepStatusCode === 'SUBMIT' }">
          <button [disabled]="userType === 'Petitioner' || userType === 'Attorney'"
            [ngClass]="{'complete':step?.stepStatusCode==='COMPLETE','inprogress': step?.stepStatusCode === 'INPROGRESS', 'new':step?.stepStatusCode === 'NEW', 'submit':step?.stepStatusCode === 'SUBMIT', 'not-editable': !step.isEditable }"
            (click)="handleStepClick(step)">
            <span class="common-bene-class-for-translation"> {{ step.stepName }}</span></button>

        </div>
        <hr class="separator">
      </div>
    </ng-template>
  </p-timeline>
  <p-timeline class="beneficiaryInitiate" align="alternate" *ngIf="primaryData?.isBeneficiaryInitiate"
    [value]="stepList">
    <ng-template pTemplate="marker" let-step>
      <span class="custom-marker" (mouseenter)="mouseEnter(step?.completionStatus)">
        <span *ngIf="!step.isCustomStep" [ngbTooltip]="step?.estimatedTime" [tooltipClass]="toolTipCustomClass"
          [ngClass]="{'complete-icon':step?.stepStatusDetails?.stepStatusCode==='COMPLETE',
              'inprogress-icon': step?.stepStatusDetails?.stepStatusCode === 'INPROGRESS', 
              'new-icon':step?.stepStatusDetails?.stepStatusCode === 'NEW', 
              'submit-icon':step?.stepStatusDetails?.stepStatusCode === 'SUBMIT',
            'overDue-icon': step?.completionStatus === 'OVERDUE' }">
        </span>
        <span *ngIf="step.isBeneficiaryVisible && step.isCustomStep" [ngbTooltip]="step?.estimatedTime"
          [tooltipClass]="toolTipCustomClass" [ngClass]="{'complete-icon':step?.stepStatusCode==='COMPLETE',
              'inprogress-icon': step?.stepStatusCode === 'INPROGRESS', 
              'new-icon':step?.stepStatusCode === 'NEW', 
              'submit-icon':step?.stepStatusCode === 'SUBMIT',
            'overDue-icon': step?.completionStatus === 'OVERDUE' }">
        </span>
      </span>
    </ng-template>
    <ng-template pTemplate="content" let-step>
      <!-- Lawfirm / Petitioner Side -->
      <div class="d-inline-flex"
        *ngIf="(step.isPetitionerAction === 1 || step.isAttorneyAction === 1) && (step.isVisible || step.isAttorneyVisible || step.isPetitionerVisible)">
        <!-- IM-20492 bcz of this story comments lock  -->
        <!-- <span class="pet-lock-unlock" *ngIf="userType === 'Petitioner' || userType === 'Attorney'">
          <div class="icon-lock-background locks task-notes-btn" [pTooltip]="step?.isBeneficiaryVisible === 0 ? 'Step Locked For Beneficiary' : 'Lock Step For Beneficiary'"
         #btnNote (click)="lockpanel.toggle($event, btnNote)">
            <span *ngIf="step?.isBeneficiaryVisible === 0" class="icn-lock"></span> <span *ngIf="step?.isBeneficiaryVisible === 1" class="icn-unlock"></span>
          </div>
          <p-overlayPanel #lockpanel appendTo="btnNote" class="lockpanel-pet" [showCloseIcon]="true" [dismissable]="true">
            <ng-template pTemplate>
              <lock-unlock-steps-library [step]="step" (lockUnlock)="updateLockUnlock($event, step)"></lock-unlock-steps-library>
            </ng-template>
          </p-overlayPanel>
          <hr class="pet-separator">
        </span> -->
        <div *ngIf="!step.isCustomStep" class=" p-shadow-2"
          [ngClass]="{'completed-border':step?.stepStatusDetails?.stepStatusCode==='COMPLETE','inprogress-border': step?.stepStatusDetails?.stepStatusCode === 'INPROGRESS', 'new-border':step?.stepStatusDetails?.stepStatusCode === 'NEW', 'submit-border':step?.stepStatusDetails?.stepStatusCode === 'SUBMIT' }">
          <button
            [ngClass]="{'complete':step?.stepStatusDetails?.stepStatusCode==='COMPLETE','inprogress': step?.stepStatusDetails?.stepStatusCode === 'INPROGRESS', 'new':step?.stepStatusDetails?.stepStatusCode === 'NEW', 'submit':step?.stepStatusDetails?.stepStatusCode === 'SUBMIT', 'not-editable': !step.isEditable}"
            (click)="step.isEditable && handleStepClick(step)"
            [class.lock]="step?.isAttorneyEditable === 0 && step?.isPetitionerEditable === 0">
            <span class="common-bene-class-for-translation">{{ step.stepName == 'Print Petition' ? 'Send for Signature &
              Generate Final' : (step.stepName == 'Print I-130 Petition' ? 'Send for Signature & Generate Final' :
              step.stepName) }}</span></button>
        </div>
        <div class=" p-shadow-2" *ngIf="step.isCustomStep"
          [ngClass]="{'completed-border':step?.stepStatusCode==='COMPLETE','inprogress-border': step?.stepStatusCode === 'INPROGRESS', 'new-border':step?.stepStatusCode === 'NEW', 'submit-border':step?.stepStatusCode === 'SUBMIT' }">
          <button
            [ngClass]="{'complete':step?.stepStatusCode==='COMPLETE','inprogress': step?.stepStatusCode === 'INPROGRESS', 'new':step?.stepStatusCode === 'NEW', 'submit':step?.stepStatusCode === 'SUBMIT', 'not-editable': !step.isEditable}"
            (click)="handleStepClick(step)">
            <span class="common-bene-class-for-translation">{{ step.stepName }}</span></button>
        </div>
        <!-- Step Notes -->
        <span id="customCaseView" *ngIf="userType === 'Petitioner' || userType === 'Attorney'">
          <button class="btn dropDownOptions dropdown-toggle" type="button" id="dropdownMenuButton"
            data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
            <i class="fa fa-ellipsis-v"></i>
          </button>
          <div class="dropdown-menu pull-right" aria-labelledby="dropdownMenuButton">
            <div>
              <div class="icon-background notes task-notes-btn" [pTooltip]="step?.notes?.noteText"
                [class.yellow]="step?.notesAvailable===true" #btnNote (click)="notepanel.toggle($event, btnNote)">
                <span class="icn-note"></span>
              </div><span>Notes</span>
            </div>
            <div class="menuSubItems" (click)="onClickNofifications(step)">
              <mat-icon>notifications</mat-icon><span>Notification</span>
            </div>
          </div>

          <!-- <div class="icon-background notes task-notes-btn" [pTooltip]="step?.notes?.noteText"
            [class.yellow]="step?.notesAvailable===true" #btnNote (click)="notepanel.toggle($event, btnNote)">
            <span class="icn-note"></span>
          </div> -->
          <p-overlayPanel #notepanel appendTo="btnNote" class="notepanel" [showCloseIcon]="true" [dismissable]="true">
            <ng-template pTemplate>
              <task-notes-lib [step]="step" (noteAdded)="updateNoteAvailability($event, step)"></task-notes-lib>
              <!-- <app-task-notes-reworked [step]="step" (noteAdded)="updateNoteAvailability($event, step)"></app-task-notes-reworked> -->
            </ng-template>
          </p-overlayPanel>
        </span>
        <!-- End -->
        <!-- Notice & Receipts -->
        <span *ngIf="step.stepName == 'Get Receipt' && !isTaskReceiptDateAvailabel && taskStatus === 'FILED'">
          <div class="icon-background">
            <i class="material-icons text-primary">hourglass_empty</i>
          </div>
          <span *ngIf="receiptETADateRange">
            <div class="d-inline-block align-bottom">
              <small>
                <div>Receipt ETA</div>
                <div class="d-inline-block text-primary">{{receiptETADateRange}}</div>
              </small>
            </div>
          </span>
          <span *ngIf="!receiptETADateRange" class="text-secondary">
            <small>Not Available</small>
          </span>
        </span>
        <!-- End -->
      </div>
    </ng-template>
    <ng-template pTemplate="opposite" let-step>
      <!-- Beneficiary Side -->
      <div class="d-inline-flex" *ngIf="step.isBeneficiaryAction === 1 && step.isVisible && !step.isCustomStep">
        <!-- Step Lock /Unlock -->
        <span *ngIf="userType === 'Petitioner' || userType === 'Attorney'">
          <div class="icon-lock-background locks task-notes-btn"
            [pTooltip]="step?.isBeneficiaryVisible === 0 ? 'Step Locked For Beneficiary' : 'Lock Step For Beneficiary'"
            #btnNote (click)="lockpanel.toggle($event, btnNote)">
            <span *ngIf="step?.isBeneficiaryVisible === 0" class="icn-lock"></span> <span
              *ngIf="step?.isBeneficiaryVisible === 1" class="icn-unlock"></span>
          </div>
          <p-overlayPanel #lockpanel appendTo="btnNote" class="lockpanel" [showCloseIcon]="true" [dismissable]="true">
            <ng-template pTemplate>
              <lock-unlock-steps-library [step]="step"
                (lockUnlock)="updateLockUnlock($event, step)"></lock-unlock-steps-library>
            </ng-template>
          </p-overlayPanel>
        </span>
        <!-- End -->
        <div class="p-shadow-2"
          [ngClass]="{'completed-border-ben':step?.stepStatusDetails?.stepStatusCode==='COMPLETE','inprogress-border-ben': step?.stepStatusDetails?.stepStatusCode === 'INPROGRESS', 'new-border-ben':step?.stepStatusDetails?.stepStatusCode === 'NEW', 'submit-border-ben':step?.stepStatusDetails?.stepStatusCode === 'SUBMIT' }">
          <button [disabled]="userType === 'Petitioner' || userType === 'Attorney'"
            [ngClass]="{'complete':step?.stepStatusDetails?.stepStatusCode==='COMPLETE','inprogress': step?.stepStatusDetails?.stepStatusCode === 'INPROGRESS', 'new':step?.stepStatusDetails?.stepStatusCode === 'NEW', 'submit':step?.stepStatusDetails?.stepStatusCode === 'SUBMIT', 'not-editable': !step.isEditable }"
            (click)="step.isEditable && handleStepClick(step)" [class.lock]="step?.isBeneficiaryVisible === 0">
            <span class="common-bene-class-for-translation">
              {{ step.stepName == 'Print Petition' ? 'Send for Signature & Generate Final' : (step.stepName == 'Print
              I-130 Petition' ? 'Send for Signature & Generate Final' : step.stepName) }}</span></button>
        </div>
      </div>
      <div class="d-inline-flex"
        *ngIf="step.isBeneficiaryAction === 1 && step.isBeneficiaryVisible && step.isCustomStep">
        <!-- Step Lock /Unlock -->
        <span *ngIf="userType === 'Petitioner' || userType === 'Attorney'">
          <div class="icon-lock-background locks task-notes-btn"
            [pTooltip]="step?.isBeneficiaryVisible === 0 ? 'Step Locked For Beneficiary' : 'Lock Step For Beneficiary'"
            #btnNote (click)="lockpanel.toggle($event, btnNote)">
            <span *ngIf="step?.isBeneficiaryVisible === 0" class="icn-lock"></span> <span
              *ngIf="step?.isBeneficiaryVisible === 1" class="icn-unlock"></span>
          </div>
          <p-overlayPanel #lockpanel appendTo="btnNote" class="lockpanel" [showCloseIcon]="true" [dismissable]="true">
            <ng-template pTemplate>
              <lock-unlock-steps-library [step]="step"
                (lockUnlock)="updateLockUnlock($event, step)"></lock-unlock-steps-library>
            </ng-template>
          </p-overlayPanel>
        </span>
        <!-- End -->
        <div class="p-shadow-2" *ngIf="step.isCustomStep"
          [ngClass]="{'completed-border-ben':step?.stepStatusCode==='COMPLETE','inprogress-border-ben': step?.stepStatusCode === 'INPROGRESS', 'new-border-ben':step?.stepStatusCode === 'NEW', 'submit-border-ben':step?.stepStatusCode === 'SUBMIT' }">
          <button [disabled]="userType === 'Petitioner' || userType === 'Attorney'"
            [ngClass]="{'complete':step?.stepStatusCode==='COMPLETE','inprogress': step?.stepStatusCode === 'INPROGRESS', 'new':step?.stepStatusCode === 'NEW', 'submit':step?.stepStatusCode === 'SUBMIT', 'not-editable': !step.isEditable }"
            (click)="handleStepClick(step)"><span class="common-bene-class-for-translation">
              {{ step.stepName }}</span></button>

        </div>
        <hr class="separator">
      </div>
    </ng-template>
  </p-timeline>
  <div class="row" *ngIf="isSimplify">
    <div class="lengendPortion p-2">
      <div class="col-12 p-0">
        <label class="p-0 m-0 common-bene-class-for-translation">Legend</label>
        <help-video-overlay-library #helpVideoComponent *ngIf="userType === 'Beneficiary'"></help-video-overlay-library>
      </div>
      <div class="ml-auto pb-3">
        <div class="mr-3 float-left d-flex align-items-center">
          <div class="float-left mr-2 legend completed"></div>
          <div class="float-left"><span class="common-bene-class-for-translation">Completed</span></div>
        </div>
        <div class="mr-3 float-left d-flex align-items-center">
          <div class="float-left mr-2 legend submitted"></div>
          <div class="float-left"><span class="common-bene-class-for-translation">Submitted</span></div>
        </div>
        <div class="mr-3 float-left d-flex align-items-center">
          <div class="float-left mr-2 legend inprogress"></div>
          <div class="float-left"><span class="common-bene-class-for-translation">In-Progress</span></div>
        </div>
        <div class="mr-3 float-left d-flex align-items-center">
          <div class="float-left mr-2 legend news"></div>
          <div class="float-left"><span class="common-bene-class-for-translation">New</span></div>
        </div>
        <div class="float-left d-flex align-items-center">
          <div class="float-left mr-2 legend over-due"></div>
          <div class="float-left"><span class="common-bene-class-for-translation">Over Due</span></div>
        </div>
      </div>
    </div>
    <!-- <div class="col-1">
      <help-video-overlay-library #helpVideoComponent></help-video-overlay-library>
    </div> -->
  </div>
</div>